// saga.js
import { call, put, takeEvery } from "redux-saga/effects";
import {
  GET_CAMPAIGN_NOTES,
  CREATE_CAMPAIGN_NOTES,
  UPDATE_CAMPAIGN_NOTES,
  DELETE_CAMPAIGN_NOTES,
} from "./actionTypes";
import {
  getCampaignNotesSuccess,
  getCampaignNotesError,
  createCampaignNotesSuccess,
  createCampaignNotesError,
  updateCampaignNotesSuccess,
  updateCampaignNotesError,
  deleteCampaignNotesSuccess,
  deleteCampaignNotesError,
} from "./actions";
import { genericDeleteRequest, genericGetRequest, genericPostRequest, genericPutRequest } from "helpers/sf_backend_helper";
import { AppConfiguration } from "config";
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper";

// Get Campaign Notes
function* onGetCampaignNotes(action) {
  try {
    const adminUser = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/all_campaign_notes/${action.payload}`, //account id
      {},
      {
        'Content-Type': 'application/json',
        Authorization: adminUser.token,
        },
    );
    yield put(getCampaignNotesSuccess(response));
  } catch (error) {
    yield put(getCampaignNotesError(error));
  }
}

// Create Campaign Notes
function* onCreateCampaignNotes(action) {
  try {
    const adminUser = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/campaign_notes`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: adminUser.token,
        }
      }
    )
    yield put(createCampaignNotesSuccess(response));
  } catch (error) {
    yield put(createCampaignNotesError(error));
  }
}

// Update Campaign Notes
function* onUpdateCampaignNotes(action) {
  try {
    const adminUser = bsh_getAdminUserDetails();
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/campaign_notes/${action.payload.id}`, //campaign note id
      {
        body: JSON.stringify({
          ...action.payload,
        }),
        headers: {
          Authorization: adminUser.token,
          "Content-Type": "application/json",
        },
      }
    );
    yield put(updateCampaignNotesSuccess(response));
  } catch (error) {
    yield put(updateCampaignNotesError(error));
  }
}

// Delete Campaign Notes
function* onDeleteCampaignNotes(action) {
  try {
    const adminUser = bsh_getAdminUserDetails();
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/campaign_notes/${action.payload}`, // campaign note id
      {
        method: "DELETE",
        headers: {
          Authorization: adminUser.token,
          "Content-Type": "application/json",
        },
      }
    );
    yield put(deleteCampaignNotesSuccess(response));
  } catch (error) {
    yield put(deleteCampaignNotesError(error));
  }
}

function* CampaignNotesSaga() {
  yield takeEvery(GET_CAMPAIGN_NOTES, onGetCampaignNotes);
  yield takeEvery(CREATE_CAMPAIGN_NOTES, onCreateCampaignNotes);
  yield takeEvery(UPDATE_CAMPAIGN_NOTES, onUpdateCampaignNotes);
  yield takeEvery(DELETE_CAMPAIGN_NOTES, onDeleteCampaignNotes);
}

export default CampaignNotesSaga;
